
import React from 'react';
import phoneIcon from '../assets/phone1-icon.png';
import mailIcon from '../assets/mail1-icon.png';
import locationIcon from '../assets/location-icon.png';
import gridBg from '../assets/grid-bg1.png';
import contactStrip from '../assets/contact-strip.png'; // Adjust the path if needed
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import IconHeadset from "../assets/icon-headset.png";
import IconRocket from "../assets/icon-rocket.png";
import IconDocument from "../assets/icon-document.png";
import IconDollar from "../assets/icon-dollar.png";
import { useLocation } from "react-router-dom";
import ClockIcon from "../assets/clock.png";
import LightBulb from "../assets/light.png";
import ConciergeImage from "../assets/concierge.png";
import newsletterIcon from '../assets/newsletter-icon.png';
import emailIcon from '../assets/email.png';
import locationicon from '../assets/location.png';
import instagram from '../assets/instagram.png';
import facebook from '../assets/facebook.png';
import youtube from '../assets/youtube.png';
import linkedin from '../assets/linkedin.png';
import x from '../assets/x.png';
import phoneicon from '../assets/phone-icon.png';
import userIcon from '../assets/user.png';
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";  
import { Link } from 'react-router-dom';
import dd from "../assets/DD.png";
import ar from "../assets/Ar.png";
import logo from "../assets/logo.svg";
import ind from "../assets/Ind.svg";
import { ChevronDown } from "lucide-react";
import emojiLeft from '../assets/emoji-left.svg';
import emojiRight from '../assets/emoji-right.svg';
import emojiParty from '../assets/emoji-party.svg';
import emojiConfetti from '../assets/emoji-confetti.svg';
import { useNavigate } from 'react-router-dom'; 
import { useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
 












export default function ContactSection() {
   const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    message: "",
    captcha: "",
  });
  const [getuserCaptcha, setgetUserCaptcha] = useState("");
   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
 
   const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");
 
  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };
 
  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);
 
  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
 
    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);
 
    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }
 
    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");
 
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8; // ±23°
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);
 
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });
 
    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);
 
  /* -- reload button click ------------------------------------------------------- */
  const handleReload = () => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };
    const handleSubscribe = async () => {
    try {
      const response = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: sessionid,
            captcha: userCaptcha,
            email: email,
            type: "Mawalog",
          }),
        }
      );
 
      const result = await response.json();
      console.log("Response:", userCaptcha, " ", data);
      setEmail("");
     setUserCaptcha("");
      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };
  const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };
   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
    const [isCompanyOpen, setIsCompanyOpen] = useState(false);
  
    const toggleMobileMenu = () => {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    };
  
    const toggleServicesDropdown = () => {
      setIsServicesOpen(!isServicesOpen);
    };
  
    const toggleIndustriesDropdown = () => {
      setIsIndustriesOpen(!isIndustriesOpen);
    };
  
    const toggleCompanyDropdown = () => {
      setIsCompanyOpen(!isCompanyOpen);
    };
  const [onStates, setOnStates] = useState([true, true, false, false]);

  useEffect(() => {
    const interval = setInterval(() => {
      setOnStates((prev) =>
        prev.map((state, index) => (index % 2 === 0 ? !state : state))
      );
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const flickerVariants = {
    animate: {
      opacity: [1, 0.5, 1],
      transition: {
        repeat: Infinity,
        duration: 0.6,
        ease: "easeInOut",
      },
    },
  };
  
 const location = useLocation();
 
  useEffect(() => {
    if (location.hash === "#contact-section") {
      const section = document.getElementById("contact-section");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  






const [dataa, setDataa] = useState("");
  const [sessionidd, setSessionidd] = useState("");
  const [tokenn, setTokenn] = useState("");
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setDataa(json.data.captcha_code);
        setSessionidd(json.data.session_id);
        setTokenn(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(dataa, 10, 22);
    }
  }, [dataa]);
  // const handleChange = (e) => {
  //   setEmail(e.target.value);
  // };
 
  const getcanvasRef = useRef(null);
  // const [captchaValue, setCaptchaValue] = useState("");
 
  /* ------------------------------------------------------------------- API fetch */
  // const fetchCaptcha = async () => {
  //   try {
  //     const res = await fetch(
  //       "https://api-uat.mawalog.com/admin/v2/api/website"
  //     );
  //     const json = await res.json();
  //     setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
  //   } catch (err) {
  //     console.error("Error fetching captcha:", err);
  //   }
  // };
 
  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);
 
  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!dataa) return; // nothing to paint yet
    const canvas = getcanvasRef.current;
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
 
    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);
 
    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }
 
    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = dataa.toString().split("");
 
    /* ========= characters (extra-uneven, extra-distorted) */
    const fonts = [
      "Arial",
      "Verdana",
      "Georgia",
      "Courier New",
      "Times New Roman",
    ];
 
    chars.forEach((ch, i) => {
      // more dramatic randomness
      const angle = (Math.random() - 0.5) * 1.4; // ±40 °
      const x = 6 + i * 14 + (Math.random() * 8 - 4);
      const y = 20 + (Math.random() * 10 - 5);
 
      ctx.save();
      ctx.translate(x, y);
 
      /* skew / stretch */
      ctx.transform(
        1 + (Math.random() * 0.2 - 0.1), // scale-X
        Math.random() * 0.35 - 0.175, // skew-Y
        Math.random() * 0.35 - 0.175, // skew-X
        1 + (Math.random() * 0.2 - 0.1), // scale-Y
        0,
        0
      );
 
      ctx.rotate(angle);
 
      /* random font & size */
      ctx.font = `bold ${18 + Math.floor(Math.random() * 6)}px ${
        fonts[Math.floor(Math.random() * fonts.length)]
      }`;
      ctx.fillStyle = "#0A3A72";
      ctx.fillText(ch, 0, 0);
 
      ctx.restore();
    });
 
    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [dataa]);
 
  /* -- reload button click ------------------------------------------------------- */
  const gethandleReload = () => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setDataa(json.data.captcha_code);
        setSessionidd(json.data.session_id);
        setTokenn(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };
 
  // const handleSubscribe = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://api-uat.mawalog.com/admin/v2/api/newsletter",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-CSRF-TOKEN": tokenn,
  //         },
  //         body: JSON.stringify({
  //           session_id: sessionidd,
  //           captcha: getuserCaptcha,
  //           email: email,
  //           type: "Mawalog",
  //         }),
  //       }
  //     );
 
  //     const result = await response.json();
  //     console.log("Response:", getuserCaptcha, " ", dataa);
  //     setEmail("");
  //     setgetUserCaptcha("");
  //     toast(result.message);
  //   } catch (error) {
  //     console.error("Error sending request:", error);
  //   }
  // };
 
  const isMobile = screenWidth <= 768;
 
  const gethandleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/website",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": tokenn,
          },
          body: JSON.stringify({
            session_id: sessionidd,
            captcha: getuserCaptcha,
            name: formData.name,
            email: formData.email,
            phone_number: formData.phone,
            message: formData.message,
            company_name: formData.company,
          }),
        }
      );
 
      const result = await response.json();
      console.log("Response:", getuserCaptcha, result);
 
      formData.name = "";
      formData.email = "";
      formData.phone = "";
      formData.message = "";
      formData.company = "";
      setCaptchaValue("");
 
      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };











  return (
    <>
    <ToastContainer position="top-right" autoClose={3000} />
   <div className="top-0 z-50 w-full">
  <div className="relative bg-[#FFE9AC] py-2 px-3 text-center text-gray-800 text-[13px] sm:text-sm md:text-base font-medium flex items-center justify-center">
    
    {/* Left Emoji */}
    <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
      <img
        src={emojiLeft}
        alt="Celebration emoji"
        className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7"
      />
    </div>

    {/* Center Text and Emojis */}
    <div className="flex flex-wrap items-center justify-center gap-1 px-6 text-center leading-tight">
      {/* Emoji group - hidden on mobile */}
      <span className="hidden sm:flex items-center gap-1">
        <img src={emojiConfetti} alt="Confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>

     <span className="text-[11px] sm:text-[12px] md:text-[13px] leading-tight">
  We are proud to announce that we have completed&nbsp;
  <span className="text-green-700 font-semibold">6 successful years!</span>
</span>

      {/* Emoji group - hidden on mobile */}
      <span className="hidden sm:flex items-center gap-1">
        <img src={emojiParty} alt="Party" className="h-4 w-4 sm:h-5 sm:w-5" />
        <img src={emojiConfetti} alt="Confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>
    </div>

    {/* Right Emoji */}
    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
      <img
        src={emojiRight}
        alt="Celebration emoji"
        className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7"
      />
    </div>
  </div>
</div>
 <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm">
            <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-2 md:px-8">
              {/* Logo */}
              <div className="flex items-center space-x-2">
                <Link to="/">
                  <img
                    src={logo}
                    alt="Lentera Logo"
                    className="h-8 w-auto"
                  />
                </Link>
              </div>
      
              {/* Hamburger Icon for Mobile */}
              <button
                className="lg:hidden flex items-center"
                onClick={toggleMobileMenu}
                aria-label="Toggle mobile menu"
              >
                <svg
                  className="h-6 w-6 text-gray-800"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={isMobileMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
                  />
                </svg>
              </button>
      
              {/* Desktop Navigation */}
  <nav
      ref={navRef}
      className="hidden lg:flex items-center space-x-6 text-sm font-medium text-gray-800 ml-13"
    >
      {/* --- Services Dropdown --- */}
      <div className="relative">
        <div className="flex items-center gap-1">
          <a
            href="#"
            className="text-black hover:text-black flex items-center"
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown('services');
            }}
          >
            Services
            <img
              src={dd}
              alt="Dropdown arrow"
              className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                openDropdown === 'services' ? 'rotate-180' : 'rotate-0'
              }`}
            />
          </a>
        </div>

        {openDropdown === 'services' && (
          <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
            {[
              { to: "/services/ai-services/", label: "AI Services" },
              { to: "/services/web-development/", label: "Web Development" },
              { to: "/services/mobile-app-development/", label: "Mobile App Development" },
              { to: "/services/software-consulting/", label: "Software Consulting" },
              { to: "/services/third-party-integration/", label: "Third Party Integration" },
              { to: "/services/custom-development/", label: "Custom Development" },
              { to: "/services/enterprise-application/", label: "Enterprise Application" },
              { to: "/services/digital-transformation/", label: "Digital Transformation" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
              >
                <div className="flex items-center">
                  <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <span className="ml-2 text-xs">{item.label}</span>
                </div>
                <img
                  src={ar}
                  alt="Right arrow"
                  className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
              </Link>
            ))}
          </div>
        )}
      </div>

      {/* --- Industries Dropdown --- */}
      <div className="relative">
        <div className="flex items-center gap-1">
          <a
            href="#"
            className="text-black hover:text-black flex items-center"
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown('industries');
            }}
          >
            Industries
            <img
              src={dd}
              alt="Dropdown arrow"
              className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                openDropdown === 'industries' ? 'rotate-180' : 'rotate-0'
              }`}
            />
          </a>
        </div>

        {openDropdown === 'industries' && (
           <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
            {[
              
              { to: "/industries/logistics/", label: "Logistics" },
              { to: "/industries/healthcare/", label: "Healthcare" },
              { to: "/industries/financial-services/", label: "Financial Services" },
              { to: "/industries/education/", label: "Education" },
              { to: "/industries/hospitality/", label: "Hospitality" },
              { to: "/industries/entertainment/", label: "Entertainment" },
              { to: "/industries/energy/", label: "Energy" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
              >
                <div className="flex items-center">
                  <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <span className="ml-2 text-xs">{item.label}</span>
                </div>
                <img
                  src={ar}
                  alt="Right arrow"
                  className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
              </Link>
            ))}
          </div>
        )}
      </div>

      {/* --- Company Dropdown --- */}
      <div className="relative">
        <div className="flex items-center gap-1">
          <a
            href="#"
            className="text-black hover:text-black flex items-center"
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown('company');
            }}
          >
            Company
            <img
              src={dd}
              alt="Dropdown arrow"
              className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                openDropdown === 'company' ? 'rotate-180' : 'rotate-0'
              }`}
            />
          </a>
        </div>

        {openDropdown === 'company' && (
          <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
            {[
              { to: "/company/our-advantages/", label: "Our advantages" },
              { to: "/company/our-story/", label: "Our Story" },
              { to: "/company/people-of-lentera/", label: "People of Lentera" },
              { to: "/company/our-brand/", label: "Our Brand" },
              { to: "https://blog.lentera.in/", label: "Blogs", external: true },
              { to: "https://www.lentera.in/contact-us/", label: "Support us", external: true },
              // { to: "/company/certifications/", label: "Certifications" },
            ].map((item) =>
              item.external ? (
                <a
                  key={item.to}
                  href={item.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
                >
                  <div className="flex items-center">
                    <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                    <span className="ml-2 text-xs">{item.label}</span>
                  </div>
                  <img
                    src={ar}
                    alt="Right arrow"
                    className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  />
                </a>
              ) : (
                <Link
                  key={item.to}
                  to={item.to}
                  className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
                >
                  <div className="flex items-center">
                    <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                    <span className="ml-2 text-xs">{item.label}</span>
                  </div>
                  <img
                    src={ar}
                    alt="Right arrow"
                    className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  />
                </Link>
              )
            )}
          </div>
        )}
      </div>

      {/* --- Contact Link --- */}
      <Link to="/Contact/" className="text-black hover:text-black">
        Contact us
      </Link>
    </nav>
      
              {/* Desktop Language Selector + CTA */}
              <div className="hidden lg:flex items-center gap-3">
                {/* <button className="flex items-center gap-2 rounded-full border border-gray-300 px-4 py-1 text-sm font-medium text-gray-700 shadow-sm">
                  <img
                    src={ind}
                    alt="India Flag"
                    className="h-4 w-4 rounded-full"
                  />
                  India (English)
                  <ChevronDown className="h-4 w-4" />
                </button> */}
                 <button
      onClick={handleClick}
      className="rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700"
    >
      Get a Free Quote
    </button>
              </div>
            </div>
      
            {/* Mobile Menu */}
            {isMobileMenuOpen && (
              <div className="lg:hidden bg-white border-t border-gray-100">
                <nav className="flex flex-col px-4 py-4 space-y-2 text-sm font-medium text-gray-800">
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleServicesDropdown}
                    >
                      Services
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isServicesOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isServicesOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/services/ai-services/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Ai Services
                        </Link>
                        <Link
                          to="/services/web-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Web Development
                        </Link>
                        <Link
                          to="/services/mobile-app-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Mobile App Development
                        </Link>
                        <Link
                          to="/services/software-consulting/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Software Consulting
                        </Link>
                        <Link
                          to="/services/third-party-integration/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Third Party Integration
                        </Link>
                        <Link
                          to="/services/custom-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Custom Development
                        </Link>
                        <Link
                          to="/services/enterprise-application/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Enterprise Application
                        </Link>
                         <Link
                          to="/services/digital-transformation/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Digital Transformation
                        </Link>
                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleIndustriesDropdown}
                    >
                      Industries
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isIndustriesOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isIndustriesOpen && (
                      <div className="mt-2 space-y-1">
                        
                        
                        <Link
                          to="/industries/healthcare/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Healthcare
                        </Link>
                        <Link
                          to="/industries/financial-services/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Financial Services
                        </Link>
                        <Link
                          to="/industries/education/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Education
                        </Link>
                        <Link
                          to="/industries/hospitality/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Hospitality
                        </Link>
                        <Link
                          to="/industries/entertainment/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Entertainment
                        </Link>
                        <Link
                          to="/industries/energy/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Energy
                        </Link>
                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleCompanyDropdown}
                    >
                      Company
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isCompanyOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isCompanyOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/company/our-advantages/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our advantages
                        </Link>
                        <Link
                          to="/company/our-story/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our Story
                        </Link>
                        <Link
                          to="/company/people-of-lentera/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          People Of Lentera
                        </Link>
                         <Link
                          to="/company/our-brand/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our Brand
                        </Link>
                        {/* <Link
                                                  to="/company/certifications/"
                                                  className="block px-4 py-2 text-xs hover:bg-gray-100"
                                                  onClick={() => setIsMobileMenuOpen(false)}
                                                >
                                                  Certifications
                                                </Link>   */}
                    <a
  href="https://blog.lentera.in/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 text-xs hover:bg-gray-100"
  onClick={() => setIsMobileMenuOpen(false)}
>
  Blogs
</a>

                        {/* <Link
                          to="/certifications"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Certifications
                        </Link> */}
                      <a
  href="https://www.lentera.in/contact-us/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 text-xs hover:bg-gray-100"
  onClick={() => setIsMobileMenuOpen(false)}
>
  Support us
</a>

                      </div>
                    )}
                  </div>
                  <Link
                    to="/Contact/"
                    className="block py-2 text-sm hover:bg-gray-100"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Contact us
                  </Link>
                  {/* <button className="flex items-center gap-2 py-2 text-sm font-medium text-gray-700">
                    <img
                      src={ind}
                      alt="India Flag"
                      className="h-4 w-4 rounded-full"
                    />
                    India (English)
                    <ChevronDown className="h-4 w-4" />
                  </button> */}
          <button
  onClick={handleClick}
  className="w-[175px] h-[44px] rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700"
>
  Get a Free Quote
</button>


                </nav>
              </div>
            )}
          </header>
 
  
    
    
    <section
      className="py-20 bg-cover bg-center"
      style={{ backgroundImage: `url(${gridBg})` }}
    >
      <div className="max-w-7xl mx-auto px-4 text-center text-white">
        <h2 className="text-4xl font-bold text-white mb-4">
          We’d love to help you
        </h2>
        <p className="text-lg text-gray-100 max-w-2xl mx-auto">
          Please feel free to get in touch using the form below. We'd love to hear your thoughts & answer any questions you may have!
        </p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16 px-4 max-w-7xl mx-auto">
        {/* Phone Card */}
        <div className="bg-[#f4f9fd] rounded-2xl shadow p-8">
          <div className="flex items-center gap-4 mb-4">
            <img src={phoneIcon} alt="Phone" className="w-8 h-8" />
            <h3 className="text-lg font-semibold text-[#1c1c1c]">Make a call</h3>
          </div>
          <p className="text-sm text-[#3d3d3d] mb-2">Let’s talk with our experts</p>
          <a
            href="tel:+914448563345"
            className="text-green-700 font-bold text-lg hover:underline"
          >
            +91-44-4856-3345
          </a>
        </div>

        {/* Mail Card */}
        <div className="bg-[#f4f9fd] rounded-2xl shadow p-8">
          <div className="flex items-center gap-4 mb-4">
            <img src={mailIcon} alt="Mail" className="w-8 h-8" />
            <h3 className="text-lg font-semibold text-[#1c1c1c]">Send a mail</h3>
          </div>
          <p className="text-sm text-[#3d3d3d] mb-2">Don't hesitate to mail</p>
          <div className="flex flex-wrap gap-2">
            {/* <a
              href="mailto:hi@lentera.in"
              className="bg-white text-blue-600 px-4 py-2 rounded-full text-sm font-medium hover:underline"
            >
              hi@lentera.in
            </a> */}
            <a
              href="mailto:info@lenteratech.com"
              className="bg-white text-blue-900 px-7 py-2 rounded-full text-sm font-medium hover:underline"
            >
              info@lenteratech.com
            </a>
          </div>
        </div>

        {/* Address Card */}
        <div className="bg-[#f4f9fd] rounded-2xl shadow p-8">
          <div className="flex items-center gap-4 mb-4">
            <img src={locationIcon} alt="Location" className="w-8 h-8" />
            <h3 className="text-lg font-semibold text-[#1c1c1c]">Address</h3>
          </div>
          <a
            href="https://www.google.com/maps/place/G1,+Plot+No,+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 font-medium text-sm hover:underline block"
          >
            G1, Plot No, 824 and 826, 3rd Main Rd, Ram Nagar South, Madipakkam, Chennai, Tamil Nadu 600091.
          </a>
        </div>
      </div>
    </section>



 
      <div>
      {/* Your entire Contact page content including the section below */}
      <section id="contact-section" className="bg-[#f8f9fb] w-full px-6 py-20">
  <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row gap-16 items-start">
   
    {/* LEFT SIDE */}
    <div className="w-full md:w-[55%] relative">
      <p className="text-green-600 font-semibold mb-4">Let us help</p>
      <h2 className="text-4xl md:text-5xl font-bold text-[#1f1f1f] mb-4">
        Get in touch with us
      </h2>
      <p className="text-lg text-gray-700 mb-10 max-w-md">
        We’re here to help—reach out anytime with questions, feedback, or just to say hello!
      </p>
 
      {/* ICONS & ANIMATION BLOCK */}
      <div className="relative w-full max-w-[380px] h-[200px] mx-auto sm:ml-0">
        {/* Rotating Clock */}
        <motion.img
          src={ClockIcon}
          alt="Clock"
          className="absolute top-0 left-0 w-12 sm:w-[60px]"
          animate={{ rotate: 360 }}
          transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
        />
 
        {/* Flickering Light */}
        <motion.img
          src={LightBulb}
          alt="Light"
          className="absolute top-0 right-0 w-[70px] sm:w-[100px]"
          variants={flickerVariants}
          animate="animate"
        />
 
        {/* 2x2 Icon Grid */}
        <div className="absolute left-1/2 -translate-x-1/2 top-[70px] grid grid-cols-2 w-[190px] h-[160px] border border-gray-200">
          {[IconHeadset, IconRocket, IconDocument, IconDollar].map((icon, index) => (
            <motion.div
              key={index}
              className="flex items-center justify-center border border-gray-200"
              animate={{
                filter: onStates[index] ? "brightness(1)" : "brightness(0.5)",
                opacity: onStates[index] ? 1 : 0.6,
              }}
              transition={{ duration: 0.3 }}
            >
              <img src={icon} alt={`icon-${index}`} className="w-[45px] h-[23.33px]" />
            </motion.div>
          ))}
        </div>
      </div>
 
      {/* Concierge Illustration */}
      <img
        src={ConciergeImage}
        alt="Concierge"
        className="w-full mt-20 max-w-[500px] mx-auto sm:ml-0"
      />
 
      {/* Quote */}
      <blockquote className="mt-10 text-lg text-[#2d2d2d] max-w-[600px]">
        <span className="text-3xl align-top leading-none">“</span>
        We’ll assign a concierge to learn your setup and guide you on how Lentera can meet your business needs through one-on-one sessions. Think of us as your own personal business consultants.
        <span className="text-3xl align-bottom leading-none">”</span>
      </blockquote>
    </div>
 
    {/* RIGHT SIDE FORM */}
  <div className="w-full md:w-[45%] bg-white rounded-xl shadow-xl p-8 sm:p-10">
              <h3 className="text-xl font-semibold text-[#1f1f1f] mb-6">
                Submit your info and our concierge will be in touch
              </h3>
              <form className="space-y-4">
                {["Your name*", "Company name*", "Email*", "Phone number*"].map(
                  (placeholder, i) => {
                    const fieldNames = ["name", "company", "email", "phone"];
                    return (
                      <input
                        key={i}
                        type="text"
                        name={fieldNames[i]}
                        placeholder={placeholder}
                        value={formData[fieldNames[i]]}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            [fieldNames[i]]: e.target.value,
                          })
                        }
                        className="w-full p-4 border-2 border-[#EBEBEB] rounded-xl focus:border-green-600 focus:outline-none transition"
                      />
                    );
                  }
                )}
 
                <textarea
                  placeholder="Message (Optional)"
                  className="w-full p-4 border-2 border-[#EBEBEB] rounded-xl h-32 resize-none focus:border-green-600 focus:outline-none transition"
                  value={formData.message}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      message: e.target.value,
                    })
                  }
                />
                <p className="text-sm text-gray-500">
                  By submitting this form, you agree to the processing of
                  personal data according to our{" "}
                  <a href="#" className="text-blue-600 underline">
                    Privacy Policy
                  </a>
                  .
                </p>
                <>
                  <style>{`
        .captcha-containerr {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 10px auto !important;
          gap: 10px !important;
         
          flex-wrap: wrap !important;
        }
        .captcha-boxx {
          width: 60px !important;
          height: 40px !important;
          border-radius: 20px !important;        
          background-color: #fff !important;
          box-shadow: 0 0 6px rgba(0, 0, 0, 0.1) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
      .captcha-inputt {
  padding: 10px 1px !important;
  border-radius: 8px !important;
  border: 2px solid #EBEBEB !important;
  outline: none; /* remove !important here */
  min-width: 100px !important;
  background: #fff !important;
  color: #000 !important;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}
 
.captcha-input:focus {
  border-color: #07862B !important;
}
 
        .subscribe-buttonn {
          padding:14px 30px!important;
          border-radius:12px!important;
          border:none!important;
          background:#fff!important;
          color:#0A3A72!important;
          font-weight:bold!important;
          cursor:pointer!important;
          margin-bottom:0!important;
        }
        @media(max-width:1024px){ .captcha-container{margin-left:50px!important;} .captcha-inputt{min-width:110px!important;} }
        @media(max-width:768px ){ .captcha-container{margin-left:40px!important;} .captcha-inputt{min-width:100px!important;} }
        @media(max-width:480px ){ .captcha-container{margin-left:20px!important;margin-right:20px!important;gap:4px!important;} .captcha-inputt{min-width:80px!important;font-size:14px!important;} }
      `}</style>
 
                  <div className="captcha-containerr">
                    <div className="captcha-boxx">
                      <canvas
                        ref={getcanvasRef}
                        id="captchaCanvas"
                        width={60}
                        height={40}
                      />
                    </div>
 
                   <button
  type="button" // 👈 Add this line
  onClick={gethandleReload}
  style={{
    background: "#07862B",
    color: "#fff",
    border: "none",
    padding: "8px",
    borderRadius: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="23 4 23 10 17 10"></polyline>
    <polyline points="1 20 1 14 7 14"></polyline>
    <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
  </svg>
</button>
 
 
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      value={getuserCaptcha}
                      onChange={(e) => setgetUserCaptcha(e.target.value)}
                      className="captcha-inputt"
                    />
 
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <button
                        style={{
                          backgroundColor: "#07862B",
                          color: "white",
                          fontSize: isMobile ? "14px" : "16px",
                          fontWeight: "bold",
                          padding: isMobile ? "10px 20px" : "12px 88px",
                          borderRadius: "30px",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onClick={(e) => gethandleSubmit(e)}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </>
                {/* <button
          type="submit"
          className="w-full bg-green-700 hover:bg-green-800 text-white py-4 rounded-full font-semibold"
        >
          SUBMIT
        </button> */}
              </form>
            </div>
  </div>
</section>
</div>

      
     <div className="w-full bg-white font-poppins py-16 px-6 md:px-16 flex flex-col md:flex-row items-center justify-between">
      
      {/* Left Side */}
      <div className="md:w-1/2 space-y-6">
        <div className="inline-block px-4 weight-500 size-16px py-2 bg-green-100 text-green-700 text-sm font-semibold rounded-full">
          Need assistance?
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
          We're Here to Help
        </h2>

        <p className="text-gray-600 text-base leading-relaxed">
          Our support team is just a message away and ready to assist you with anything—fast, friendly, and reliable. Reach out to us anytime — our team will respond promptly to assist you.
        </p>

        <a
  href="https://www.lentera.in/why-us/" // Replace with your link
  className="inline-flex items-center gap-2 bg-green-700 hover:bg-green-800 transition text-white px-6 py-3 rounded-full font-semibold"
>
  QUICK CONNECT
  <span className="text-xl">→</span>
</a>

      </div>

      {/* Right Side - Seamless Scrolling Strip */}
      <div className="relative mt-10 md:mt-0 w-[494px] h-[380px] overflow-hidden">
        {/* Blur Overlays */}
        <div className="absolute top-0 left-0 w-16 h-full z-10 bg-gradient-to-r from-white via-white/80 to-transparent pointer-events-none" />
        <div className="absolute top-0 right-0 w-16 h-full z-10 bg-gradient-to-l from-white via-white/80 to-transparent pointer-events-none" />

        {/* Scrolling Wrapper */}
        <div className="flex w-max animate-scroll-seamless whitespace-nowrap">
          {/* Repeat image enough times to ensure seamless loop */}
          {[...Array(4)].map((_, i) => (
            <img
              key={i}
              src={contactStrip}
              alt={`contact-strip-${i}`}
              className="h-[380px] w-[494px] object-cover shrink-0"
            />
          ))}
        </div>

        {/* Custom Animation */}
        <style>{`
          @keyframes scroll-seamless {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          .animate-scroll-seamless {
            animation: scroll-seamless 20s linear infinite;
          }
        `}</style>
      </div>
    </div>
    <section className="bg-white py-20 w-full">
      {/* Section Header */}
      <div className="text-center px-4 sm:px-6 md:px-10 lg:px-20 mb-10 max-w-screen-xl mx-auto">
        <h2 className="text-4xl font-bold text-[#1c1c1c] mb-4">Our location</h2>
        <p className="text-lg text-[#3d3d3d]">
          Feel free to visit our office to learn more about our products, services, and work culture.
        </p>
      </div>

      {/* Full-Width Google Map */}
      <div className="w-full h-[500px]">
        <iframe
          title="Lentera Technologies Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.0616475436946!2d80.2090835!3d12.9636427!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d628d45f3a7%3A0xb699ddbfaf9c98be!2sLentera%20Technologies%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1720000000000!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
       <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
       {/* Top newsletter */}
       <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
         {/* Left Side */}
         <div className="flex items-start md:items-center gap-4 md:gap-6">
           <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
           <h2 className="text-xl md:text-[28px] font-bold leading-tight">
             Join our newsletter to <br className="hidden md:block" />
             keep up to date with us!
           </h2>
         </div>
 
   <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
  {/* Newsletter input */}
 <div
  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
  style={{ borderRadius: "6px" }}
>
  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
  <input
    type="email"
    value={email}
    onChange={handleChange}
    placeholder="Enter your email"
    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
  />
</div>
 
 
  {/* Captcha line (canvas + refresh + input + subscribe button) */}
{/* Outer wrapper to center the row */}
<div className="w-full flex justify-center">
  <div className="flex items-center gap-3">
    {/* Captcha canvas */}
    <div className="captcha-box">
      <canvas
        ref={canvasRef}
        id="captchaCanvas"
        width={60}
        height={40}
        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
      />
    </div>
 
    {/* Refresh button */}
    <button
      onClick={handleReload}
      style={{
        background: "#07862B ",
        color: "#fff",
        border: "none",
        padding: "6px",
        borderRadius: "6px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="23 4 23 10 17 10"></polyline>
        <polyline points="1 20 1 14 7 14"></polyline>
        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
      </svg>
    </button>
 
    {/* Captcha input */}
    <input
      type="text"
      placeholder="Enter captcha"
      value={userCaptcha}
      onChange={(e) => setUserCaptcha(e.target.value)}
      className="captcha-input"
    />
 
    {/* Subscribe button */}
    <button className="subscribe-button" onClick={handleSubscribe}>
      Subscribe
    </button>
  </div>
</div>
 
<style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>
 
</div>
       </div>
 
       {/* Divider */}
       <div className="border-t border-gray-700 w-full" />
 
       {/* Main Footer Content */}
       <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
         {/* Company Info */}
         <div className="w-full lg:w-[30%]">
           <a href="http://localhost:3000/" aria-label="Lentera Home">
  <img src={nlen} alt="Lentera logo" className="mb-6" />
</a>
           <p className="text-[#d4d4d4] leading-relaxed">
             We are highly experienced in offering software development, mobile
             application development, software consulting and project management
             delivery.
           </p>
           {/* Social Icons */}
           <div className="flex gap-4 mt-6 flex-wrap">
  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
    <img src={inst} alt="Instagram" className="w-8 h-8" />
  </a>
  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
    <img src={face} alt="Facebook" className="w-8 h-8" />
  </a>
  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
    <img src={you} alt="YouTube" className="w-8 h-8" />
  </a>
  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
  </a>
  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
    <img src={twi} alt="X" className="w-8 h-8" />
  </a>
</div>

         </div>
 
         {/* Services */}
           <div className="w-full sm:w-[45%] md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
           <ul className="space-y-2 text-[#d4d4d4]">
  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
</ul>
         </div>
 
 
         {/* Insights */}
         <div className="w-full sm:w-[45%] md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
           <ul className="space-y-2 text-[#d4d4d4]">
  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
</ul>
         </div>
 
         {/* Contact */}
         <div className="w-full md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
          <div className="flex items-start gap-3 mb-3">
  <img src={phone} alt="phone" className="w-5 h-5 mt-1" />
  <div>
    <p className="text-[#999] text-sm">Phone number</p>
    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
      +91-44-4856-3345
    </a>
  </div>
</div>

<div className="flex items-start gap-3 mb-3">
  <img src={mail} alt="email" className="w-5 h-5 mt-1" />
  <div>
    <p className="text-[#999] text-sm">Email address</p>
    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
      info@lenteratech.com
    </a>
  </div>
</div>

           <div className="flex items-start gap-3">
  <img src={loc} alt="location" className="w-5 h-5 mt-1" />
  <div>
    <p className="text-[#999] text-sm">Location</p>
    <a
      href="https://www.google.com/maps/place/G1,+Plot+No,+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
      target="_blank"
      rel="noopener noreferrer"
      className="text-white font-medium text-sm hover:underline block"
    >
      G1, Plot No, 824 and 826, 3rd<br />
      Main Rd, Ram Nagar South,<br />
      Madipakkam, Chennai,<br />
      Tamil Nadu 600091
    </a>
  </div>
</div>

         </div>
       </div>
     </div>
   </footer>
 
   {/* Bottom Section */}
   <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>
    
    </>
  );
}
